module.exports = __webpack_public_path__ + "static/media/SystemsUpdate.563a076d.png";